import { render, staticRenderFns } from "./CardBadFood.vue?vue&type=template&id=d0fed4da&"
import script from "./CardBadFood.vue?vue&type=script&lang=js&"
export * from "./CardBadFood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports